module.exports = __webpack_public_path__ + "media/images/emblems/Blason_saxon_suisse-73f3ad8265e84e6dfc335012c6899172.svg";